import React, { useRef, useState } from 'react';
import { Row, Col, Form } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { ActionButton, IconButton } from '@fluentui/react/lib/Button';
import { SpinnerSize, TooltipHost } from '@fluentui/react';
import { base64ToArrayBuffer, isNullUndefined, isNullUndefinedOrEmpty, saveByteArray, showMessage } from '../../../../common/Helpers';
import PropTypes from 'prop-types';
import Loading from '../../../../components/Templates/Site/Loading';
import { FILE_MAX_SIZE } from '../../../../configurations/application.config';
import { addTransversalDocument } from '../../../../services/sBook/document.service';
import { __MessageTypes } from '../../../../common/Dictionaries';
import { deleteAchievementDocuments, getAchievementDocuments } from '../../../../services/sNotificationAlerts/notificationAlerts.service';
import { envBlobDocumentUpload, envDocumentGetUrl, envDocumentValidate } from '../../../../services/Env/transversal.service';

const NotificationTaskDocumentBox = (props) => {

    const { 
        inputParam_ObjAchieveValidationId = null,
        inputParam_SetMessageConfig = null,
        inputParam_EditMode = false,
        inputParam_DocumentAddApiUrl = false,
        inputParam_ObjDocument = null,
        inputParam_SetObjDocument = null,
        inputParam_ParentRowClassNames = "py-2 mt-3"
    } = props;

    const { t } = useTranslation();
    const fileUploadControl = useRef();
    const [uploadInProgress, setUploadInProgress] = useState(false);
    const [downloadInProgress, setDownloadInProgress] = useState(false);

    const [selectedFile, setSelectedFile] = useState(null);

    const onCancelUpload = () => {
        setSelectedFile(null);
        fileUploadControl.current.value = "";
        showMessage(inputParam_SetMessageConfig, false, __MessageTypes.WARNING, '')
    }

    const onUploadFile = async () => {
        if (!isNullUndefinedOrEmpty(selectedFile)) {
            //const ojbClientFormData = new FormData();
            //ojbClientFormData.append("file", selectedFile);
            //ojbClientFormData.append("id", inputParam_ObjAchieveValidationId);
            //ojbClientFormData.append("url", inputParam_DocumentAddApiUrl);
            if (!isNullUndefined(selectedFile)) {
                if (handleFileInput(selectedFile)) {
                    showMessage(inputParam_SetMessageConfig, false, __MessageTypes.ERROR, '')
                    setUploadInProgress(true);
                    await envDocumentGetUrl(inputParam_DocumentAddApiUrl, inputParam_ObjAchieveValidationId, selectedFile.name).then(async (responseGetUrl) => {
                        if (responseGetUrl.data.succeeded === true) {
                            await envBlobDocumentUpload(responseGetUrl.data.data.url, responseGetUrl.data.data.fileName, selectedFile).then(async (responseAzure) => {
                                if (responseAzure.data === "" && responseAzure.status === 201) {
                                    await envDocumentValidate(responseGetUrl.data.data.document_id).then(async (responseValidate) => {
                                        if (responseValidate.data.succeeded === true) {
                                            if (responseValidate.data.data.result_validate === true) {
                                                inputParam_SetObjDocument && inputParam_SetObjDocument(responseGetUrl.data.data.document_id, selectedFile.name)
                                                showMessage(inputParam_SetMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                                                setSelectedFile(null);

                                                setUploadInProgress(false);
                                            }
                                            else {
                                                showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t(responseValidate.data.data.result_validate_msg))
                                                setUploadInProgress(false);
                                            }
                                        }
                                        else {
                                            showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t(responseValidate.data.message))
                                            setUploadInProgress(false);
                                        }
                                    })
                                    .catch((error) => {
                                        showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                        setUploadInProgress(false);
                                    });
                                }
                                else {
                                    showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                    setUploadInProgress(false);
                                }
                            })
                            .catch(async (error) => {
                                await envDocumentValidate(responseGetUrl.data.data.document_id, 0).then(async () => {
                                    showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                    setUploadInProgress(false);
                                })
                                .catch((error) => {
                                    showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                    setUploadInProgress(false);
                                });
                            });
                        } else {
                            showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t(responseGetUrl.data.message))
                            setUploadInProgress(false);
                        }
                        setSelectedFile(null);
                        setUploadInProgress(false);
                    })
                    .catch(() => {
                        showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                        setUploadInProgress(false);
                    });
                }
                else {
                    showMessage(inputParam_SetMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-filesizeerror'))
                }
            }
            else {
                showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-selectfile'))
            }
        }
        else {
            showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-selectfile'))
            setUploadInProgress(false);
        }
    };
    
    const onDownloadDocument = (documentId, fileName) => {
        setDownloadInProgress(true);
        getAchievementDocuments([documentId]).then((response) => {
            saveByteArray(fileName, base64ToArrayBuffer(response.data.data));
            setDownloadInProgress(false);
        }).catch((ex) => {
            console.log(ex)
            showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            setDownloadInProgress(false)
        });
    }

    const onDeleteDocument = (documentId) => {
        deleteAchievementDocuments(documentId).then((response) => {
            if (response.data.succeeded) {
                inputParam_SetObjDocument && inputParam_SetObjDocument(null)
                showMessage(inputParam_SetMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
            }
            else {
                showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }
        }).catch(() => {
            showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
        });
    }

    const handleFileInput = (e) => {
        // handle validations
        const file = !isNullUndefined(e.target) ? e.target.files[0] : e;
        let flag = false;
        
        if (file) {
            const maxSizeInMB = FILE_MAX_SIZE;
            const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

            if (file.size > maxSizeInBytes) {
                showMessage(inputParam_SetMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-filesizeerror'))
                setSelectedFile(file);
            }
            else {
                flag = true;
                setSelectedFile(file);
            }
        }

        return flag;
    };

    return  <Row className={inputParam_ParentRowClassNames}>
                <Col xl={4} className='my-auto'>
                    {t('data-lang-lbl-backupdocuments')}
                </Col>
                {
                    (isNullUndefined(inputParam_ObjDocument) || isNullUndefined(inputParam_ObjDocument.documentId)) &&
                    <Col xl={8} className='my-auto'>
                        <div className='d-flex float-end'>
                            {
                                inputParam_EditMode &&
                                <>
                                    <div className='d-flex align-items-center'>
                                        <TooltipHost content={
                                            <>
                                                <div>{'Tool TIP Archivos Permitidos: "7z", "doc", "docx", "eml", "jpeg", "jpg", "msg", "ods", "pdf", "png", "ppt", "pptx", "rar", "txt", "xls", "xlsb", "xlsx", "xps", "zip“. Peso: 80mb.'}</div>
                                                <div>{'Si tiene problemas con estos formatos, sugerimos guardar nuevamente el archivo con un programa estándar, ejemplo: Archivo de imagen “.jpg”  o “.png” utilizar abrir en “Paint” y volver a guardar.'}</div>
                                            </>
                                        }>
                                            <Form.Control ref={fileUploadControl} type="file" size="sm" onChange={ handleFileInput } />
                                        </TooltipHost>
                                    </div>
                                    {
                                    !uploadInProgress &&
                                    <ActionButton id="btnUpload" iconProps={{ iconName: 'Upload' }} onClick={() => onUploadFile()} allowDisabledFocus disabled={selectedFile === null} >
                                        { t('data-lang-btn-upload') }
                                    </ActionButton>
                                    }
                                    {
                                    !uploadInProgress &&
                                    <ActionButton id="btnUpload" iconProps={{ iconName: 'RemoveFilter' }} onClick={() => onCancelUpload()} allowDisabledFocus disabled={selectedFile === null} >
                                        { t('data-lang-btn-cancel') }
                                    </ActionButton>
                                    }
                                    {
                                        uploadInProgress &&
                                        <Loading
                                            inputParam_ShowLoading={true}
                                            inputParam_ShowText={false}
                                            inputParam_Width={'25px'}
                                            inputParam_Height={'25px'}
                                            inputParam_Left={""}
                                            inputParam_Style={{marginTop: 0}}
                                            inputParam_ColClassName={"me-2"}
                                            inputParam_MarginLeft={"auto"}
                                            inputParam_SpinnerSize={SpinnerSize.medium} />
                                    }
                                </>
                            }
                        </div>
                    </Col>
                }
                {
                    (!isNullUndefined(inputParam_ObjDocument) && !isNullUndefined(inputParam_ObjDocument.documentId)) &&
                    <Col xl={8}>
                        {
                            downloadInProgress &&
                            <Loading
                                inputParam_ShowLoading={true}
                                inputParam_ShowText={false}
                                inputParam_Width={'25px'}
                                inputParam_Height={'25px'}
                                inputParam_Left={""}
                                inputParam_Style={{marginTop: 0}}
                                inputParam_ColClassName={"me-2"}
                                inputParam_MarginLeft={"auto"}
                                inputParam_SpinnerSize={SpinnerSize.medium} />
                        }
                        {
                            !downloadInProgress &&
                            <div className='d-flex'>
                                <div className='my-auto'>{inputParam_ObjDocument.name}</div>
                                <div className='d-flex ms-auto'>
                                    <div><IconButton iconProps={{iconName: "Download"}} onClick={() => onDownloadDocument(inputParam_ObjDocument.documentId, inputParam_ObjDocument.name)} /></div>
                                    {
                                        inputParam_EditMode &&
                                        <div><IconButton iconProps={{iconName: "Delete"}} onClick={() => onDeleteDocument(inputParam_ObjDocument.documentId)} /></div>
                                    }
                                </div>
                            </div>
                        }
                    </Col>
                }
            </Row>
}


NotificationTaskDocumentBox.propTypes = {
    inputParam_ObjAchieveValidationId: PropTypes.number.isRequired,
    inputParam_SetMessageConfig: PropTypes.func.isRequired,
    inputParam_EditMode: PropTypes.bool.isRequired,
};

export default NotificationTaskDocumentBox;